<template>
  <div class="BgTabBox__card">
    <header class="BgTabBox__card-header">
      <ul class="BgTabBox__tab-heads">
        <li
          class="BgTabBox__tab-head"
          v-for="tab in tabs"
          :key="tab"
          :class="{
            'BgTabBox__tab-head--active': activeTab === tab,
          }"
          v-on:click="switchTab(tab)"
        >
          <slot :name="tabHeadSlotName(tab)">{{ tab }}</slot>
        </li>
      </ul>
    </header>
    <main class="BgTabBox__card-body">
      <div class="BgTabBox__tab-panel">
        <slot :name="tabPanelSlotName"></slot>
      </div>
    </main>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
export default {
  props: {
    initialTab: String,
    tabs: Array,
  },
  data() {
    return {
      activeTab: this.initialTab,
    };
  },
  computed: {
    tabPanelSlotName() {
      return `tab-panel-${this.activeTab}`;
    },
  },
  methods: {
    tabHeadSlotName(tabName) {
      return `tab-head-${tabName}`;
    },

    switchTab(tabName) {
      this.activeTab = tabName;
    },
  },
};
</script>
